import React from "react";
import InvParentLinkRow from "./InvParentLinkRow";
import withView from '../../cmn/docAutomation/withView';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormTitle from '../../../library/form/components/FormTitle';

import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../../library/layout/Index";

const InvParentLink = (props) => {
    const { formObject, viewData } = props;
    if(!viewData)
        return(null)
        
    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Expense Claim' />
                    </span>
                </UiTitle>
            </UiViewHeading>
            <UiViewContent>
                <div className="uiSingleColumn">
                    <div className="uiGridCol">
                        <div className="uiResetFloats" style={{display:"inline-block"}}>
                            <div style={{float:"left"}}>
                                <FormButton formObject={formObject} rowKey="" headerKey="parentLink"
                                    action={{ actionId: "import",  paramName: "parentLinkSH", actionParam: {is:"3", mode:"full", tdtId:"%dataList.valLDT", tdId:"0", imdtId:"%dataList.imdtId", imdocId:"%dataList.imdocId"},containerKey: "redirect" }}
                                    className="uiActionButton" text={<SarasTrans value="Add New" />}>
                                </FormButton>
                            </div>
                        </div>
                        <div className="uiResetFloats" style={{ display: "inline-block" }}>
                            <div className="phViewContent uiSecContents">
                                {
                                    Object.values(viewData).map((row, index) => (
                                        <InvParentLinkRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </UiViewContent>
        </UiView>
    )
}

export default withView(InvParentLink, "invTrnParentInv", "")

